import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class ApiService {

    constructor(private http: HttpClient) {
    }

    public getOrders(id): Observable<any> {
        return this.http.get('/api/orders', {params: {branchId: id}});
    }

    public postOrder(orderData: any): Observable<any> {
        return this.http.post('/api/orders', orderData);
    }

    public getOrderSearch(serial: any): Observable<any> {
        return this.http.get('/api/orders/search/by-serial?serial=' + serial);
    }

    public putOrder(id, data): Observable<any> {
        return this.http.put('/api/orders/' + id, data);
    }

    public getOrder(id): Observable<any> {
        return this.http.get('/api/orders/' + id);
    }

    public putOrderUpdateItem(id, idItem, serial): Observable<any> {
        return this.http.put('/api/orders/' + id + '/update-item/' + idItem, {serialNo: serial});
    }

    public putOrderClose(id): Observable<any> {
        return this.http.put('/api/orders/' + id + '/close', {});
    }

    public getDefaultAddress(): Observable<any> {
        return this.http.get('/api/orders/default-address');
    }

    public downloadOrder(id): Observable<any> {
        return this.http.get('/api/order-pdf/' + id, {
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }


    /*****product*****/
    public getProducts(): Observable<any> {
        return this.http.get('/api/product');
    }

    public getProductById(id): Observable<any> {
        return this.http.get('/api/product/' + id);
    }

    public postProduct(data: any): Observable<any> {
        return this.http.post('/api/product', data);
    }

    public getProduct(searchText = ''): Observable<any> {
        return this.http.get('/api/product', {params: {filter: searchText}});
    }

    public putProduct(id, data): Observable<any> {
        return this.http.put('/api/product/' + id, data);
    }

    public deleteProduct(id): Observable<any> {
        return this.http.delete('/api/product/' + id);
    }

    /*******reclamation ******/
    public getReclamation(): Observable<any> {
        return this.http.get('/api/reclamation');
    }

    public postReclamation(data: any): Observable<any> {
        return this.http.post('/api/reclamation', data);
    }

    /*******branch ******/
    public getBranch(): Observable<any> {
        return this.http.get('/api/branch');
    }

}
